<div class="col-sm-12">
  <div class="card">
    <div class="card-header">Dynamic Forms</div>
    <div class="card-body">
      <app-dynamicformbuilder [fields]="getFields()"></app-dynamicformbuilder>
    </div>
  </div>
</div>

<div class="col-sm-12">
  <div class="form-group" [formGroup]="form">
    <label>JSON</label>
    <textarea formControlName="fields" class="form-control" rows="20"></textarea>
   </div>
</div>
